import { FC } from 'react';
import { Typography } from '@mui/material';
import { DATE_FORMAT } from 'utils/enums';
import { formatUTCDateView, getApartmentTitle } from 'utils/helpers';
import { IBillsListItemResponse } from 'utils/types';
import styles from './index.module.scss';

interface BillsListItemProps {
	data: IBillsListItemResponse;
	onClick: () => void;
	title: string;
	description?: string;
}

export const BillsListItem: FC<BillsListItemProps> = ({ data, onClick, description, title }) => {
	const apartmentTitle = data.apartmentLocation ? getApartmentTitle(data.apartmentLocation) : '';

	return (
		<div className={styles.card} onClick={onClick}>
			<Typography variant="subtitle1">{title}</Typography>

			{!!description && (
				<Typography className={styles.card__description} variant="body2" color="--color-neutral-500">
					{description}
				</Typography>
			)}

			<Typography variant="body2" color="--color-neutral-500">
				{formatUTCDateView(data.paidAt ?? data.createdAt, DATE_FORMAT.RADABANK_TOKEN_DATE)}
			</Typography>
			{!!apartmentTitle && <Typography variant="body1">{apartmentTitle}</Typography>}
		</div>
	);
};
